
import Chainlink from "../../../assets/filled/Chainlink.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ChainlinkIcon({ className, dataTestid = "ChainlinkIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Chainlink data-testid={dataTestid} className={classes} {...rest} />
  );
}
